<div class="markdown-container" [innerHTML]="convertedMarkdown"></div>
